module.exports = __webpack_public_path__ + "home/en-US/js/home-tabs/images/academy-tab-inactive-mb-8c9ec74c6bd794f70e435d5a5a66c124.png";


//////////////////
// WEBPACK FOOTER
// ./home/en-US/js/home-tabs/images/academy-tab-inactive-mb.png
// module id = GhdE
// module chunks = 0